import { LoadingPage } from "@/component-nextv3/LoadingPage";
import { useResponsive } from "@/core-nextv3/util/useResponsive";
import { getGameUrl } from "@/core-nextv3/ximax2/ximax2.api";
import { AUTH_SETTING, REVALIDATE_SETTING } from "@/setting/setting";
import type { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { useContext, useState } from "react";
import { CardLive } from "../CasinoComponents/CardLive";
import { AuthContext } from "../context/AuthContext";
import { useProtectedAuthMeta } from "../context/useProtectedAuthMeta";
import { getCasinoLobbies } from "../utils/getCasinoLobbies";
import withHeader from "../utils/withHeader";
import styles from "./styles.module.scss";

export default function LiveCasinoPage({ lobbies, account }: any) {
	const { t } = useTranslation();
	const [_, setGameUrls] = useState<any>([]);
	const { user } = useContext(AuthContext);
	const { isClient } = useResponsive();

	// useEffect(() =>
	// {
	//     const resultBalance = collectAccountGameBalanceAll({
	//         currency : "KRW",
	//         document : {
	//             referencePath : user?.referencePath
	//         }
	//     })
	// }, [ user ])

	// useEffect(() =>
	// {
	//     loadUrls()
	// }, [])

	const _loadUrls = async () => {
		const collection = [];

		for (const game of lobbies) {
			const setting: any = {
				currency: "KRW",
				gameId: game.id,
				lang: "kr",
				document: { referencePath: user?.referencePath },
			};

			const result = await getGameUrl(setting);

			if (result?.status && result?.data?.returnCode === 0) {
				game.url = result?.data?.gameUrl;
			}

			collection.push(game);
		}

		setGameUrls(collection);
	};

	const loadProtectedAuth = useProtectedAuthMeta(AUTH_SETTING, "", "/");

	if (!loadProtectedAuth) {
		return <LoadingPage />;
	}

	if (!isClient) {
		return <></>;
	}

	return (
		<div className={styles.container}>
			<div className={styles.casino}>
				<div className={styles.textContainer}>
					<img src="/assets/img/casinocash.png" alt="casinocash" />
					<div className={styles.headingContainer}>
						<div className={styles.heading}>{t("cassino ao vivo")}</div>
						{/* <div className={styles.subHeading}>
                            {lobbies?.length +
                " " +
                t(
                    "fornecedores de jogos de cassino ao vivo estão disponíveis."
                )}
                        </div> */}
					</div>
				</div>

				<div className={styles.items}>
					{lobbies?.map(
						(lobby: any) =>
							lobby?.status && (
								<CardLive
									game={lobby}
									key={lobby.id}
									maintenance={lobby?.maintenance || account?.deactivatedCasino}
								/>
							),
					)}
				</div>
			</div>
		</div>
	);
}

export const getStaticProps: GetStaticProps = ({ locale }) =>
	withHeader(async (props: any) => {
		return {
			props: {
				locale: locale,
				lobbies: (await getCasinoLobbies()) || null,
				deactivatedCasino: props?.account || null,
			},
			revalidate: REVALIDATE_SETTING,
		};
	});

export { getStaticProps as GetStaticProps, LiveCasinoPage };
